import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/PayForClaimReportButton';

// FOR ONE GRAPHQL QUERY
export const FETCH_CLAIM_REPORT_PRICE = defineAsyncActionTypes(`${prefix}/FETCH_PRICE`);

export const PAY_FOR_CLAIM_REPORT = defineAsyncActionTypes(`${prefix}/PAY`);



// WEBPACK FOOTER //
// ./src/store/graphql/PayForClaimReportButton/action-types.js